export let controller = new AbortController();

export function resetController(): void {
  controller.abort();
  controller = new AbortController();
}
